var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// components/ge-radiogroup.ts
import { ElementsRadioButton, ElementsRadioGroup } from "@adornis/forms/x-radiogroup";
import { customElement } from "lit/decorators.js";
var GermaniumRadioButton = class extends ElementsRadioButton {
  styles() {
    return [
      {
        ":host": { cursor: "pointer", userSelect: "none", "-webkit-tap-highlight-color": "transparent" },
        ":host([disabled])": { pointerEvents: "none", filter: "grayscale(1)", opacity: ".5" },
        "#knob": {
          width: "22px",
          height: "22px",
          borderRadius: "50%",
          border: `2px solid ${this.value.value ? this.colors.accent : this.colors.neutral_100}`,
          padding: "2px",
          transition: "backgroundColor .12s, color .12s",
          background: this.disabled ? this.colors.accent : "transparent",
          color: this.value.value ? this.colors.on.accent : "unset"
        },
        "#knob-content": {
          background: this.colors.accent,
          height: "100%",
          width: "100%",
          borderRadius: "50%"
        }
      }
    ];
  }
};
GermaniumRadioButton = __decorateClass([
  customElement("ge-radiobutton")
], GermaniumRadioButton);
var GermaniumRadioGroup = class extends ElementsRadioGroup {
};
GermaniumRadioGroup = __decorateClass([
  customElement("ge-radiogroup")
], GermaniumRadioGroup);
export {
  GermaniumRadioButton,
  GermaniumRadioGroup
};
